module.exports = __webpack_public_path__ + "images/39783dc.png";